<template>
  <div class="rating-container pt-10 px-2">
    <p class="text-gray-500 font-bold text-2xl mb-2">How would you rate your experience?</p>
    <div class="stars">
      <svg v-for="star in 5" :key="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="star"
        :class="{ active: star <= selected_rating }" @click="selectRating(star)">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22l1.18-7.86-5-4.87 6.91-1.01L12 2z" />
      </svg>
    </div>

    <p :class="rating_color" class="font-semibold mt-3 text-lg">{{ rating_description }}</p>

    <p class="text-gray-400 text-base font-semibold mb-5 mt-6 italic">
      {{ selected_rating < 5 ? 'What can be improved?' : 'Yay! Let us know what you liked' }} </p>

        <!-- Improvement Category Selection -->
        <div class="flex flex-wrap text-sm justify-center items-center gap-3">
          <div v-for="(category, index) in categories" :key="index" @click="toggleCategory(category)"
            class="px-3 py-1 rounded-full cursor-pointer transition-all font-medium"
            :class="{ 'bg-yellow-100 text-yellow-600': selected_categories.includes(category), 'bg-gray-100 text-gray-500': !selected_categories.includes(category) }">
            {{ category }}
          </div>
        </div>


        <div class="flex flex-row justify-center align-center items-center w-full mt-8" style="gap: 2rem;">
          <Button :button_text="'Skip'" :theme="'bg-white border-2 border-theme-secondary text-theme-secondary'"
            :max_width="'max-w-full'" @click="close" />
          <Button :button_text="'Submit'" :theme="'bg-theme-secondary'" :max_width="'max-w-full'" :disabled="isSubmitDisabled" 
            @click="submitRating" />
        </div>
  </div>
</template>

<script>
import mixin from "@/mixin";
import User from "@/services/User";
import Button from "@/components/controls/ButtonControl.vue";

export default {
  name: "v-modal",
  mixins: [mixin],
  components: {
    Button,
  },
  data() {
    return {
      selected_rating: 5,
      previous_rating: 5,
      selected_categories: [],
      categories: ['Connectivity', 'Accuracy', 'Convenience', 'Reliability', 'Ease of Use', 'Security', 'Accessibility'],
      hash: this.$store.state.credentials.hash,
      uuid: this.$store.state.credentials.uuid,
    };
  },
  computed: {
    rating_description() {
      switch (this.selected_rating) {
        case 1: return "Needs Improvement";
        case 2: return "Average";
        case 3: return "Good";
        case 4: return "Very Good";
        case 5: return "Excellent!";
        default: return "";
      }
    },
    rating_color() {
      switch (this.selected_rating) {
        case 1:
          return "text-gray-400";
        case 2:
          return "text-red-600";
        case 3:
          return "text-orange-400";
        case 4:
          return "text-orange-600";
        case 5:
          return "text-yellow-500";
        default:
          return "text-theme-primary";
      }
    },
    isSubmitDisabled() {
      if (this.selected_rating === 0) return true;
      if (this.selected_rating < 5 && this.selected_categories.length === 0) return true;
      return false;
    }
  },
  methods: {
    selectRating(score) {
      const wasFive = this.previous_rating === 5;
        const isFive = score === 5;

        if (wasFive !== isFive) {
          // Rating crossed the 5 <-> 1-4 boundary
          this.selected_categories = [];
        }

        this.selected_rating = score;
        this.previous_rating = score;
    },
    toggleCategory(category) {
      const index = this.selected_categories.indexOf(category);
      if (index === -1) {
        this.selected_categories.push(category);
      } else {
        this.selected_categories.splice(index, 1);
      }
    },
    submitRating() {
      this.$emit('close');
      if (!this.is_submitted && this.selected_rating > 0) {
        this.is_submitted = true;

        const remarks = JSON.stringify(this.selected_categories);
        User.submitRating(this.hash, 3, this.selected_rating, this.uuid, remarks)
          .then(() => {
            console.log('Rating submitted');
          })
          .catch((error) => {
            console.error('Error submitting rating:', error);
          });
      }
    },
    close() {
      this.$emit('close'); // Emit close event for Skip
    }
  },
};
</script>



<style scoped>
.rating-container {
  text-align: center;
}

.stars {
  font-size: 4rem;
  display: flex;
  justify-content: center;
  color: #d3d3d3;
  margin-top: 1rem;
}

.star {
  width: 5rem;
  /* Adjust size */
  height: 5rem;
  margin: 0 0.2rem;
  fill: #d3d3d3;
  cursor: pointer;
  transition: fill 0.2s;
}

.star.active {
  fill: #FFC107;
}
</style>